import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "inline-flex rounded-none",
  role: "group"
}

import { PropType, ref, watch } from 'vue';
import {
  ICapSuaChuaResponseBase,
  ITaiKhoanKeToanResponse,
} from '@/core/interfaces/ApiResponses';
import { useLoading } from '@/core/hooks/use-loading';
import { CapSuaChuaService } from '@/core/services/CapSuaChuaService.service';
import { swalErrNotification } from '@/core/helpers/utils';
import { DetailModalShell } from '@/components/shared/modal';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import ResponsiveLayout from '@/layout/_shared/ResponsiveLayout.vue';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';
import { useDateTime } from '@/core/hooks/use-date-time-hook';


export default /*#__PURE__*/_defineComponent({
  __name: 'CapSuaChuaDetailModal',
  props: {
  id: {
    type: Number as PropType<number | undefined>,
    default: undefined,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props;

const capSuaChuaDetail = ref<ICapSuaChuaResponseBase | null>(null);

const { startLoading, endLoading } = useLoading();

const { ButtonsType, ButtonTypeColors } = useButtonCustom();

const { formatDisplayingDate } = useDateTime();

const taiKhoanDisplay = ({ matk, mact, tentk }: ITaiKhoanKeToanResponse) =>
  `${matk} / ${mact || '-'} / ${tentk}`;

const fetchData = async () => {
  if (!props.id) return;

  try {
    startLoading();

    const {
      data: { data },
    } = await CapSuaChuaService.get(props.id);

    capSuaChuaDetail.value = data;

    endLoading();
  } catch (error) {
    endLoading();
    swalErrNotification(error);
  }
};

watch(
  () => props.id,
  () => {
    fetchData();
  }
);

const emit = __emit;

const closeModal = () => {
  capSuaChuaDetail.value = null;

  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DetailModalShell), {
    "is-display": !!capSuaChuaDetail.value,
    title: "Cấp sửa chữa",
    "lottie-topic": "ke-hoach-sua-chua",
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ButtonCustom, {
          classes: `rounded-none m-0`,
          "button-type": _unref(ButtonsType).CANCEL,
          "color-type": _unref(ButtonTypeColors).DANGER,
          "delay-time": 0,
          onClick: closeModal
        }, {
          "button-label": _withCtx(() => [
            _createTextVNode("Đóng")
          ]),
          _: 1
        }, 8, ["button-type", "color-type"])
      ])
    ]),
    default: _withCtx(() => [
      (capSuaChuaDetail.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("ID:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(LabelCustom, { "is-bolder": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(capSuaChuaDetail.value.id), 1)
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Tên:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(LabelCustom, { "is-bolder": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(capSuaChuaDetail.value.ten_cap_sc), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ngày tạo:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(LabelCustom, { "is-bolder": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(formatDisplayingDate)(new Date(capSuaChuaDetail.value.created_at))), 1)
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ngày cập nhật:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(LabelCustom, { "is-bolder": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(formatDisplayingDate)(new Date(capSuaChuaDetail.value.updated_at))), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("T/khoản kế toán:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(LabelCustom, { "is-bolder": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(taiKhoanDisplay(capSuaChuaDetail.value.tk_ketoan)), 1)
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Mô tả:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(LabelCustom, { "is-bolder": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(capSuaChuaDetail.value.mo_ta || '-'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-display"]))
}
}

})